import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Standard shadcn/ui class-merging helper. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Display-only caption: first line of the scraped caption with hashtags
 * and "link in bio" spam stripped. The stored caption is untouched — this
 * is purely so list/grid titles read like titles instead of tag dumps.
 */
export function displayCaption(caption: string | null | undefined): string {
  const cleaned = ((caption ?? "").split("\n")[0] ?? "")
    .replace(/#\S+/g, "")
    .replace(/link in bio\.?/gi, "")
    .replace(/\s{2,}/g, " ")
    .trim();
  return cleaned || "(no caption)";
}
